<pcp-slide-sync-toolbar-button
        [matIcon]="icon"
        [fontSet]="fontSet"
        (toggle)="toggleBookpageListDialog()"
        [turnedOn]="(isActivated$ | async) === true"
        [disabled]="(isDisabled$ | async) === true"
></pcp-slide-sync-toolbar-button>
